export default __webpack_public_path__ + "static/media/onramper.90cfef5f.png";